import React, { useEffect, useState } from "react";
import { MapPin, Clock } from "lucide-react";

const STATUS_LINE = {
  en_route: "Your chauffeur is on the way.",
  on_location: "Your chauffeur has arrived.",
  customer_in_car: "Sit back and enjoy the ride.",
  in_progress: "Sit back and enjoy the ride.",
};

function useClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 15000); return () => clearInterval(id); }, []);
  return now;
}

export default function WelcomeBoard({ trip }) {
  const now = useClock();
  const time = now.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  const date = now.toLocaleDateString([], { weekday: "long", month: "long", day: "numeric" });

  return (
    <section data-testid="welcome-board" className="relative h-full flex flex-col justify-between p-8 md:p-12 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse at 20% 10%, rgba(212,175,55,0.14), transparent 55%)" }}/>
      <div className="relative flex items-center gap-4">
        <img src="/logos/monogram.png" alt="" className="w-14 h-14 object-contain"/>
        <div className="leading-tight">
          <div className="font-serif text-xl text-[#F5F2EB] tracking-wide">Delux Limo</div>
          <div className="text-[10px] tracking-[0.32em] uppercase text-[#A1A1AA]">Trans Group</div>
        </div>
      </div>

      <div className="relative">
        {trip?.active ? (
          <div data-testid="welcome-active">
            <div className="overline mb-4" data-testid="welcome-status">{STATUS_LINE[trip.status] || "Welcome aboard."}</div>
            <h1 className="font-[Outfit] text-5xl md:text-6xl xl:text-7xl font-light tracking-tighter leading-[1.02] text-[#F5F2EB]" data-testid="welcome-headline">
              Welcome, <span className="italic text-[#D4AF37]">{trip.first_name}!</span>
              <br/>
              {trip.destination
                ? <>Your ride to <span className="font-normal">{trip.destination}</span> is ready.</>
                : <>Your chauffeur is at your service{trip.hours ? ` for the next ${trip.hours} hours` : ""}.</>}
            </h1>
            <div className="mt-8 flex flex-wrap gap-6 text-sm text-[#A1A1AA]">
              {trip.pickup && <span className="inline-flex items-center gap-2"><MapPin size={14} className="text-[#D4AF37]"/>{trip.pickup}{trip.destination ? ` → ${trip.destination}` : ""}</span>}
              {trip.driver_name && <span className="inline-flex items-center gap-2 uppercase tracking-[0.18em] text-xs">Chauffeur · <span className="text-[#F5F2EB]">{trip.driver_name}</span></span>}
            </div>
          </div>
        ) : (
          <div data-testid="welcome-generic">
            <div className="overline mb-4">Arrive with distinction</div>
            <h1 className="font-[Outfit] text-5xl md:text-6xl xl:text-7xl font-light tracking-tighter leading-[1.02] text-[#F5F2EB]" data-testid="welcome-headline">
              Welcome aboard<br/><span className="italic text-[#D4AF37]">Delux Limo Trans Group.</span>
            </h1>
            <p className="mt-6 text-[#A1A1AA] max-w-md">Complimentary water is in the console. Choose your music on the right — your chauffeur is happy to adjust the climate.</p>
          </div>
        )}
      </div>

      <div className="relative flex items-end justify-between text-[#A1A1AA]">
        <div className="inline-flex items-center gap-2 text-sm"><Clock size={14} className="text-[#D4AF37]"/>{date}</div>
        <div className="font-[Outfit] text-4xl md:text-5xl font-light tracking-tight text-[#F5F2EB]" data-testid="welcome-clock">{time}</div>
      </div>
    </section>
  );
}
